<template>
   <div>
      <v-container>
         <v-dialog
            v-model="modal"
            persistent
            width="500px"
            height="500px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="420px">
               <v-row no-gutters>
                  <v-col cols="12">
                     <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                        <v-toolbar-title>
                           Copy Group
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2">Cancel </v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2">OK </v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-form ref="formcopy" v-model="formvalid">
                  <v-row no-gutters>
                     <v-col cols="6" md="6" class="px-2">
                        <v-card flat>
                           <v-select
                              v-model="termyearselect"
                              :items="termyear"
                              item-text="termyeartext"
                              item-value="id"
                              label="Select Term"
                              return-object
                              :rules="[(v) => !!v || 'Term is required']"
                           >
                           </v-select>
                        </v-card>
                     </v-col>
                     <v-col cols="6" md="6" class="px-2">
                        <v-select
                           v-model="edit_schedule"
                           label="CCA Schedule"
                           :items="ScheduleFiltered"
                           item-text="schedule_name"
                           item-value="id"
                           return-object
                           required
                           :rules="[(v) => !!v || 'Schedule is required']"
                        >
                        </v-select>
                     </v-col>
                  </v-row>
                  <v-row no-gutters>
                     <v-col cols="12" md="10" class="px-2">
                        <v-text-field
                           v-model="edit_cca_name"
                           label="Group Name"
                           :rules="[(v) => !!v || 'Name is required']"
                        ></v-text-field>
                     </v-col>
                     <v-col cols="12" md="10" class="px-2">
                        <v-text-field
                           v-model="edit_cca_description"
                           label="Group Description"
                           :rules="[(v) => !!v || 'Description is required']"
                        ></v-text-field>
                     </v-col>
                  </v-row>
                  <v-row no-gutters>
                     <v-col cols="12" md="6" class="px-2">
                        <datepicker-dialog
                           labelname="Publish Date"
                           :indate.sync="edit_publish_date"
                           @return-date="onPublishDateChange"
                           :rules="[(v) => !!v || 'Publish date is required']"
                        >
                        </datepicker-dialog>
                     </v-col>
                     <v-col cols="12" md="6" class="px-2">
                        <datepicker-dialog
                           labelname="Closing Date"
                           :indate.sync="edit_closing_date"
                           @return-date="onClosingDateChange"
                           :rules="[(v) => !!v || 'Closing date is required']"
                        >
                        </datepicker-dialog>
                     </v-col>
                  </v-row>
                  <v-row no-gutters>
                     <v-col cols="12" md="8" class="px-2">
                        <v-checkbox
                           class="my-0"
                           label="Include Event Master"
                           v-model="copy_eventmaster"
                        ></v-checkbox>
                     </v-col>
                     <v-col cols="12" md="8" class="px-2">
                        <v-checkbox
                           class="my-0"
                           label="Include Administrators"
                           v-model="copy_adminmaster"
                        ></v-checkbox>
                     </v-col>
                  </v-row>
               </v-form>
            </v-sheet>
         </v-dialog>
      </v-container>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import DatepickerDialog from "@/components/DatepickerDialog.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         ConfirmDlg,
         DatepickerDialog,
      },

      data() {
         return {
            formvalid: true,
            termyear: [],
            termyearselect: null,
            scheduledata: [],
            cca_id: "",
            edit_schedule: null,
            edit_cca_name: "",
            edit_cca_description: "",
            edit_publish_date: this.$globalstore.currentDateISOString().substr(0, 10),
            edit_closing_date: this.$globalstore.currentDateISOString().substr(0, 10),
            copy_eventmaster: false,
            copy_adminmaster: false,
            resolve: null,
            reject: null,
            modal: false,
         };
      },
      computed: {
         ScheduleFiltered() {
            if (this.termyearselect) {
               let data = this.scheduledata.filter((x) => {
                  return x.term == this.termyearselect.term && x.year == this.termyearselect.year;
               });
               return data;
            } else return this.scheduledata;
         },
      },

      methods: {
         open(group) {
            this.cca_id = group.cca_id;
            this.edit_cca_name = group.cca_name;
            this.edit_cca_description = group.cca_description;
            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         onPublishDateChange(date) {
            this.edit_publish_date = date;
         },

         onClosingDateChange(date) {
            this.edit_closing_date = date;
         },

         OkBtnClick() {
            if (this.$refs.formcopy.validate()) {
               let payload = {
                  term_id: this.termyearselect.id,
                  cca_year: this.termyearselect.year,
                  cca_term: this.termyearselect.term,
                  schedule_id: this.edit_schedule.id,
                  cca_id: this.cca_id,
                  cca_name: this.edit_cca_name,
                  cca_description: this.edit_cca_description,
                  publish_date: this.edit_publish_date,
                  closing_date: this.edit_closing_date,
                  eventmaster: this.copy_eventmaster,
                  adminmaster: this.copy_adminmaster,
               };

               this.resolve(true);
               this.modal = false;
               this.$emit("input", payload);
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
               return;
            }
         },
         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         async LoadScheduleList() {
            await this.$http({
               url: "/cca/getschedulemasterlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.$refs.confirm
                        .open("Error", response.data.message, {
                           color: "red",
                           noconfirm: true,
                        })
                        .then((reply) => {});
                  } else {
                     this.scheduledata = response.data.scheduledata;
                  }
               }
            });
         },
      },
      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.termyear = this.$globalstore.termyearlist;
            this.LoadScheduleList();
         }
      },
   };
</script>
